import { AnalyticsRequest, GroupBy, Metric, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';

export var WidgetTreeMap: Widget = {
    type: 'treeMap',
    id: 'tree-map',
    name: 'Tree Map - Legacy',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        // Note: All global variables like reportingEngine, report, filters, and projections
        // are injected via AnalyticsRequest.getRequests()
        new AnalyticsRequest({
            limit: 6,
            projections: [
                new Metric({
                    STORY_MESSAGE: { dimensionName: 'IMPACT', heading: 'Web_Impact' },
                }),
            ],
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.topicName },
                    INBOUND_MESSAGE: { dimensionName: 'SN_TYPE' },
                    PLATFORM: { dimensionName: 'SN_TYPE' },
                    BENCHMARKING: { dimensionName: 'BENCHMARKING_SN_TYPE' },
                    PAID: { dimensionName: 'adCreativeType' },
                    ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                    RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                    STORY_MESSAGE: { dimensionName: 'STORY' },
                    TWITTER: { dimensionName: 'TRENDING_TOPIC' },
                    COMMUNITY: { source: ListeningDimensions.activity },
                    SAM: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    AUDIENCE_ACTIVITY: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Tree Map',
        size: WIDGET_LABEL_SIZE.primary,
        enabled: false,
        textShadow: TEXT_SHADOW_DEFAULT,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        labelSize: 20,
        metricValueSize: 35,
        metricPercentChangeSize: 20,
        metricNameSize: 15,
        highlightPercentChange: false,
        showMetricValue: true,
        showMetricName: true,
        showMetricChange: false,
        showSentiment: false,
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        portrait: {
            widgetOrientation: 'portrait',
        },
    },
};
